import React, { useState, useRef, useEffect } from 'react';
import { NavLink, useLocation } from 'react-router-dom';

const links = [
  { to: '/', label: 'Home' },
  { to: '/project1', label: 'Insurance Projects' },
  { 
    label: 'Rust Crates', 
    dropdown: [
      { to: '/rust-crates/cli-chat', label: 'cli-chat' },
      { to: '/rust-crates/intense-pomodoro', label: 'intense-pomodoro' },
      { to: '/cli_input', label: 'cool_cli_input' }
    ]
  },
  { to: '/blog', label: 'Blog' },
  { to: '/experience', label: 'Experience' },
  { to: '/chat', label: 'Chat with AI' },
];

const NavigationBar = ({ theme, toggleTheme }) => {
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const dropdownRef = useRef(null);
  const location = useLocation();

  const getLinkClass = ({ isActive }) => (
    `site-nav__link${isActive ? ' site-nav__link--active' : ''}`
  );

  const isRustActive = location.pathname.startsWith('/rust-crates') || location.pathname === '/cli_input';

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setDropdownOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  // Close dropdown on route change
  useEffect(() => {
    setDropdownOpen(false);
  }, [location.pathname]);

  return (
    <nav className="site-nav">
      <div className="site-nav__inner">
        <ul className="site-nav__list">
          {links.map((link) => {
            if (link.dropdown) {
              return (
                <li key="rust-crates-dropdown" className="site-nav__dropdown-container" ref={dropdownRef}>
                  <button
                    type="button"
                    className={`site-nav__link site-nav__dropdown-toggle${isRustActive ? ' site-nav__link--active' : ''}`}
                    onClick={() => setDropdownOpen((prev) => !prev)}
                    aria-expanded={dropdownOpen}
                  >
                    Rust Crates ▾
                  </button>
                  {dropdownOpen && (
                    <div className="site-nav__dropdown-menu">
                      {link.dropdown.map((sub) => (
                        <NavLink
                          key={sub.to}
                          to={sub.to}
                          className={getLinkClass}
                          onClick={() => setDropdownOpen(false)}
                        >
                          {sub.label}
                        </NavLink>
                      ))}
                    </div>
                  )}
                </li>
              );
            }

            return (
              <li key={link.to}>
                <NavLink
                  to={link.to}
                  end={link.to === '/'}
                  className={getLinkClass}
                >
                  {link.label}
                </NavLink>
              </li>
            );
          })}
        </ul>
        <button className="theme-toggle" onClick={toggleTheme} aria-label="Toggle Theme">
          <span className="theme-toggle__icon">{theme === 'founder' ? '🚀' : '💼'}</span>
          <span>{theme === 'founder' ? 'Founder Mode' : 'VC Mode'}</span>
        </button>
      </div>
    </nav>
  );
};

export default NavigationBar;
